import OverviewContext from 'store/overview-context';
import { useContext } from 'react';
import amountFormat from 'utils/amountFormatter';
import styles from './Hardship.module.scss';
import { Button, Selectmenu, Textbox } from 'components/generic';
import { getValueById } from 'utils/dropdownUtils';
import TextFormatter from 'utils/textFormatter';
import { cloneDeep } from 'lodash';

const Hardship = props => {
	const overviewContext = useContext(OverviewContext);

	const getLang = key => {
		return overviewContext?.langObj?.content?.[key] || '';
	};

	const getLangDropdown = list => {
		const obj = cloneDeep(list);
		obj.forEach(elm => (elm.value = getLang(elm?.key?.replaceAll(' ', '_')?.toUpperCase())));
		return obj;
	};

	const handleInputs = (val, key) => {
		overviewContext?.setCreateObj(prevState => ({ ...prevState, [key]: val }));
	};

	const hsConfig = overviewContext?.overviewData?.wf_linkConfiguration?.hardshipConfiguration;
	const categoryList = hsConfig?.categoryList?.map(el => ({ key: el, value: TextFormatter(el) }));

	return (
		<div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
			<h3 className={styles.amount}>{amountFormat({ value: overviewContext?.overviewData?.bd_dueAmt, currencyCode: overviewContext?.overviewData?.bd_currencyCode })}</h3>
			<div className='row'>
				<div className='col-12'>
					<Selectmenu
						label={getLang('HARDSHIP_REASON')}
						infoContent={getLang('INFO_HARDSHIP_REASON')}
						disabled={overviewContext?.overviewData?.hardship?.length}
						value={getValueById(overviewContext?.createObj?.hs_reason || overviewContext?.overviewData?.hardship?.at()?.ah_details?.hs_reason, overviewContext?.langObj?.key !== 'ENGLISH' ? getLangDropdown(categoryList) : categoryList)}
						placeholder={getLang('SELECT')}
						mandatory
						onChange={data => handleInputs(data, 'hs_reason')}
						menuOptions={overviewContext?.langObj?.key !== 'ENGLISH' ? getLangDropdown(categoryList) : categoryList}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-12'>
					<Textbox
						placeholder={getLang('EX_HARDSHIP')}
						infoContent={getLang('INFO_COMMENTS')}
						disabled={overviewContext?.overviewData?.hardship?.length}
						maxlength={255}
						onChange={e => handleInputs(e?.target?.value, 'hs_comments')}
						value={overviewContext?.createObj?.hs_comments || overviewContext?.overviewData?.hardship?.at()?.ah_details?.hs_comments}
						label={getLang('COMMENTS')}
					/>
				</div>
			</div>
			<Button primary full label={getLang('SAVE')} disabled={overviewContext?.overviewData?.hardship?.length} onSubmit={props.onHardshipSave} />
		</div>
	);
};

export default Hardship;
